import React, { Component } from "react";
import PublishBook from "../../../PublishBook/PublishBook";

class EditAuthorBooks extends Component {
  render() {
    return (
      <PublishBook editStatus={true} bookId={this.props.match.params.bookId} />
    );
  }
}

export default EditAuthorBooks;
